export interface IStoreData<T> {
  data: T | undefined;
  isLoading: boolean;
  state: 'init' | 'completed' | 'waiting' | 'error';
}

export class StoreData<T> implements IStoreData<T> {
  data: T | undefined;
  isLoading: boolean;
  state: 'init' | 'completed' | 'waiting' | 'error';
  constructor() {
    this.state = 'init';
    this.data = undefined;
    this.isLoading = false;
  }

  update(state: StoreData<T>['state'], item?: StoreData<T>['data']) {
    this.state = state;
    if (state === 'completed' && !item) {
      this.state = 'error';
      return this;
    }
    this.data = item;
    this.isLoading = state === 'waiting';
    return this;
  }
}
